import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { Observable } from "rxjs";
import { KeycloakService } from "src/app/services/keycloak.service";
import { AsyncPipe } from "@angular/common";
import { map } from "rxjs/operators";
import { FmsService } from "src/app/services/fms.service";
import { getIsEmpty } from "src/app/utils/array";
import { AccordionModule } from "@storeblocks/accordion-ng";
import { createKeyCloakFmsKey } from "src/app/components/list-advisor-accesses/createKeyCloakFmsKey";
import { FmsPipe } from "src/app/modules/shared/pipes/fms.pipe";
import { KEYCLOAK_NO_RESOURCE_ROLE } from "src/app/components/list-advisor-accesses/constants";

@Component({
  selector: "app-list-advisor-accesses",
  standalone: true,
  imports: [AsyncPipe, AccordionModule, FmsPipe],
  templateUrl: "./list-advisor-accesses.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListAdvisorAccessesComponent {
  keycloakService = inject(KeycloakService);
  fmsService = inject(FmsService);

  readonly advisorResourceRoles$: Observable<string[]>;
  readonly translatedRoles$: Observable<string[]>;

  constructor() {
    this.advisorResourceRoles$ = this.keycloakService.parsedIdToken$.pipe(
      map((parsedIdToken) => {
        const roles = parsedIdToken?.on_behalf_of?.resource_role ?? [];
        if (getIsEmpty(roles)) {
          return [KEYCLOAK_NO_RESOURCE_ROLE];
        }
        return roles.map((role: string) => createKeyCloakFmsKey(role));
      }),
    );

    this.translatedRoles$ = this.advisorResourceRoles$.pipe(
      map((roles) => roles.map((role) => this.fmsService.getText(role))),
    );
  }
}
